<script context="module">

    let switchCount = 0

</script>

<script>

    export let label = null
    export let checked = false

    const id = `switch-${switchCount++}`

</script>

<div class="field">
    <input {id} bind:checked type="checkbox" class="switch is-rounded is-primary">
    <label for={id}>
        {#if label}
            { label }
        {/if}
    </label>
</div>
